import {
    SET_CURRENT_SCENE,
    REQUEST_SCENES, RECIEVE_SCENES
} from '../constants/actionTypes';
import { showErrorModal } from './modal';
import { getBody } from './helpers';
import { getBackendUrl } from '../env';

export const setCurrentScene = scene => ({
    type: SET_CURRENT_SCENE,
    scene: scene
});

const requestScenes = () => ({
    type: REQUEST_SCENES
});

const recieveScenes = json => ({
    type: RECIEVE_SCENES,
    scenes: json
});

const shouldFetchValidScenes = state => {
    // If we have scenes dont fetch
    if (state.scene.all && state.scene.all.length) {
         return false;
    }

    // If we are fetching scenes dont fetch
    if (state.fetchingScenes) {
        return false;
    }

    return true;
};

const fetchScenes = dispatch => {
    dispatch(requestScenes());
    return fetch(`${getBackendUrl()}/api/v1/data/activities?onlySceneNames=true`)
        .then(getBody)
        .then(json => dispatch(recieveScenes(json.scenes)))
        .catch(reason => dispatch(showErrorModal(`${reason}`)));
};

export const fetchScenesIfOK = () => (dispatch, getState) => {
    if (shouldFetchValidScenes(getState())) {
        return dispatch(fetchScenes);
    }
};



// WEBPACK FOOTER //
// ./src/actions/scene.js